import React, { useContext } from "react";
export const useUser = () => {
    var _a;
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUser must be used only within the UserContext");
    }
    let testForm = null;
    if (context.user) {
        const idSegments = (_a = context.user) === null || _a === void 0 ? void 0 : _a.id.split("|");
        testForm = idSegments[idSegments.length - 1];
    }
    return { user: context.user, form: testForm };
};
export const UserContext = React.createContext({
    user: null,
    setUser: (user) => { },
});
